import Repository from "./Repository";

const resource="/tournaments";

export default {

    get() {
        return Repository.get(resource);
    },
    getEvent(eid) {
        return Repository.get(resource+"/"+eid);
    },
    getBracketRender(eid,bracketid) {
        return Repository.get(resource+"/"+eid+"/brackets/"+bracketid+"/render");
    },
    getGroupTable(eid,groupid) {
        return Repository.get(resource+"/"+eid+"/groups/"+groupid+"/table");
    }
}